import React, { useState, Fragment } from 'react';
import { storiesOf } from '@storybook/react-native';
import { View, ScrollView } from 'react-native';
import { Text } from 'src/components/Typography';
import { PanelHeader } from 'src/components/PanelHeader';
import { PlatformPadding } from 'src/components/PlatformPadding';
import { Counter } from 'src/components/Counter';
import HomeIcon from 'src/assets/icons/home.svg';
import DashboardIcon from 'src/assets/icons/pie-chart.svg';
import FeedIcon from 'src/assets/icons/list.svg';
import ProfileIcon from 'src/assets/icons/user.svg';
import MusicIcon from 'src/assets/icons/music.svg';
import { TabBar, TabBarItem } from 'src/components/TabBar';

const Example1 = () => {
  const [active, setActive] = useState(0);

  return (
    <Fragment>
      <PanelHeader>🗂 TabBar</PanelHeader>
      <ScrollView>
        <PlatformPadding vertical horizontal>
          <View>
            <Text>
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Accusantium aliquid animi
              assumenda beatae deserunt doloremque et harum impedit iusto laborum magnam maiores
              maxime molestias nesciunt non nostrum perspiciatis placeat, provident quas quasi
              quidem ratione repellendus soluta vel velit? Assumenda blanditiis dolores ducimus
              earum facilis impedit ipsam iusto laboriosam laborum maiores maxime molestias nesciunt
              praesentium repellendus sed sequi, ullam. Aspernatur autem consectetur consequuntur,
              cupiditate dolor ea facere fugiat laboriosam molestias quo rem sed sit, voluptatum.
              Accusamus commodi corporis dolores ea explicabo illum maiores omnis pariatur,
              perferendis quam quis reprehenderit sed similique sit tempore tenetur vero. Dolore ea
              eaque illo laborum odit. Lorem ipsum dolor sit amet, consectetur adipisicing elit.
              Beatae doloremque illo velit? At aut cupiditate eaque fugiat magni maiores, nihil
              numquam recusandae tenetur ullam velit voluptas, voluptates. Autem earum eius ipsam
              officia optio quae, quod tempore temporibus unde. Aspernatur, commodi dignissimos
              ducimus excepturi magnam magni molestiae non perspiciatis qui ratione saepe vel
              voluptatibus voluptatum. Alias, aliquam architecto consequatur, cumque dolor eos esse
              excepturi exercitationem fugit iusto laudantium, libero molestiae nesciunt nisi non
              qui quibusdam quo soluta vel voluptates. Distinctio enim eveniet hic possimus totam.
              Deserunt dolores in incidunt laudantium magni nostrum officia officiis praesentium
              recusandae! Ab consequuntur dolores facilis molestiae. Lorem ipsum dolor sit amet,
              consectetur adipisicing elit. Accusantium blanditiis consequatur corporis cupiditate
              dolorum earum error esse mollitia nemo officia provident quae quidem recusandae soluta
              suscipit vel velit, voluptas. Eum minima ratione repellendus, sapiente temporibus vel!
              Assumenda autem beatae blanditiis dolor earum facilis fuga, iure nihil non odit
              possimus quae rem repellendus sed vel? Consequuntur id illum, ipsum necessitatibus rem
              tenetur. Deleniti deserunt dolorem, impedit iste, molestias nihil nobis provident quo
              repellat, repellendus rerum saepe similique sint. A alias aperiam aspernatur,
              assumenda consequuntur exercitationem, minima nam provident, reiciendis similique sunt
              voluptas! Cumque ea eius eos in natus sunt, vero voluptate.
            </Text>
          </View>
        </PlatformPadding>
      </ScrollView>
      <TabBar>
        <TabBarItem
          label="Home"
          icon={<HomeIcon />}
          badge={<Counter variant="prominent" size="xs" />}
          active={active === 0}
          onPress={() => setActive(0)}
        />
        <TabBarItem
          label="Dashboard"
          icon={<DashboardIcon />}
          active={active === 1}
          onPress={() => setActive(1)}
        />
        <TabBarItem
          label="Feed"
          icon={<FeedIcon />}
          active={active === 2}
          onPress={() => setActive(2)}
        />
        <TabBarItem
          label="Music"
          icon={<MusicIcon />}
          badge={
            <Counter size="s" variant="prominent">
              5
            </Counter>
          }
          active={active === 3}
          onPress={() => setActive(3)}
        />
        <TabBarItem
          label="Profile"
          icon={<ProfileIcon />}
          active={active === 4}
          onPress={() => setActive(4)}
        />
      </TabBar>
    </Fragment>
  );
};

storiesOf('TabBar', module).add('Default', () => <Example1 />);
